import { MaasRuntimeType } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';

import type { PipelineContext } from '../../../core/types';
import type { TcPluginSpec } from './schema';

/** 训练集群表单转插件规格，保留 SKU 预置所需的扁平字段。 */
export function tcFromForm(values: Record<string, unknown>, _ctx: PipelineContext): TcPluginSpec {
  return values;
}

/** 训练集群插件规格回填到表单。 */
export function tcToForm(spec: TcPluginSpec): Record<string, unknown> {
  return spec;
}

/** 训练集群 SKU 表单初始值（运行时类型不在资源配置步采集，固定 ContainerInstance）。 */
export function tcGetInitialFormValues(): Record<string, unknown> {
  return {
    maasInferenceSource: 'custom',
    runtime: { type: MaasRuntimeType.ContainerInstance },
  };
}
